import axios from 'axios';

/**
 * A shared instance for ICS API
 */
var IcsResource$1 = axios.create({
  baseURL: process.env.BASE_API_ENDPOINT
});

/**
 * AccountCreationV1
 */

/**
 * POST LoginToAccount
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { string } [args.email]
 * @param { string } [args.password]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const loginToAccount = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`token`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

/**
 * POST CreateIcsUser
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { number } [args.affiliateId]
 * @param { number } [args.clientId]
 * @param { string } [args.company]
 * @param { string } [args.email]
 * @param { string } [args.firstName]
 * @param { boolean } [args.isTeamAdmin]
 * @param { string } [args.lastName]
 * @param { string } [args.password]
 * @param { string } [args.role]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createIcsUser = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`users`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

var index$q = /*#__PURE__*/Object.freeze({
	__proto__: null,
	loginToAccount: loginToAccount,
	createIcsUser: createIcsUser
});

/**
 * AffiliateV1
 */

/**
 * GET GetAffiliatesByLevel
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.affiliateId] Affiliate ID of affiliate or sub-affiliate (required)
 * @param { String } [args.searchText] Search text used to filter affiliates
 * @param { String } [args.parentAffiliateId] Filter for parent affiliate ID
 * @param { String } [args.statusSearch] Filter for affiliate status (active or disabled)
 * @param { String } [args.order] Name of property to order
 * @param { String } [args.orderBy] Type of ordering (&quot;asc&quot; or &quot;desc&quot;)
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getAffiliatesByLevel = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`level-affiliates`, {
    params: {
      affiliateId: args.affiliateId,
      searchText: args.searchText,
      parentAffiliateId: args.parentAffiliateId,
      statusSearch: args.statusSearch,
      order: args.order,
      orderBy: args.orderBy,
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetAffiliateById
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.affiliateId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getAffiliateById$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`affiliates/${args.affiliateId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * POST CreateAffiliate
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { string } [args.name]
 * @param { number } [args.parentId]
 * @param { string } [args.status]
 * @param { boolean } [args.isArchived]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createAffiliate = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`affiliates`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * PATCH UpdateAffiliate
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.affiliateId]
 * @param { string } [args.name]
 * @param { number } [args.parentId]
 * @param { string } [args.status]
 * @param { boolean } [args.isArchived]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateAffiliate = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.patch(`affiliates/${args.affiliateId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * DELETE DeleteAffiliate
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.affiliateId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteAffiliate = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.delete(`affiliates/${args.affiliateId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

var index$p = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getAffiliatesByLevel: getAffiliatesByLevel,
	getAffiliateById: getAffiliateById$1,
	createAffiliate: createAffiliate,
	updateAffiliate: updateAffiliate,
	deleteAffiliate: deleteAffiliate
});

/**
 * ApiKeysV1
 */

/**
 * GET GetApiKeys
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getApiKeys = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`api-keys`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * POST CreateApiKey
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { number } [args.userId]
 * @param { Object } [args.domains]
 * @param { string } [args.domains.0]
 * @param { Object } [args.ips]
 * @param { string } [args.ips.0]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createApiKey = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`api-keys`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * DELETE DeleteApiKey
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.apiKeyId] API key ID
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteApiKey = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.delete(`api-keys/`, {
    params: {
      apiKeyId: args.apiKeyId,
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

var index$o = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getApiKeys: getApiKeys,
	createApiKey: createApiKey,
	deleteApiKey: deleteApiKey
});

/**
 * CampaignsV1
 */

/**
 * GET GetCampaignsByLevel
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.affiliateId] Affliate ID of campaigns (required)
 * @param { String } [args.clientId] Client ID of campaigns
 * @param { String } [args.userAffiliateId] Affliate ID of the user
 * @param { String } [args.searchText] Search text used to filter campaigns
 * @param { String } [args.affiliateSearch] Fliter for affliate ID related to campaigns
 * @param { String } [args.clientSearch] Fliter for client ID related to campaigns
 * @param { String } [args.order] Name of property to order
 * @param { String } [args.orderBy] Type of ordering (&quot;asc&quot; or &quot;desc&quot;)
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCampaignsByLevel = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`level-campaigns`, {
    params: {
      affiliateId: args.affiliateId,
      clientId: args.clientId,
      userAffiliateId: args.userAffiliateId,
      searchText: args.searchText,
      affiliateSearch: args.affiliateSearch,
      clientSearch: args.clientSearch,
      order: args.order,
      orderBy: args.orderBy,
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetCampaigns
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCampaigns = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`campaigns`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetCampaignById
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCampaignById$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`campaigns/${args.campaignId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * POST CreateCampaign
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { object } args.formData
 * @param { string } [args.formData.active] &quot;True&quot; by default
 * @param { string } [args.formData.name] Name of this campaign  (required)
 * @param { string } [args.formData.emailSubject] Email subject of this campaign
 * @param { string } [args.formData.fromEmail] Email address of this campaign
 * @param { string } [args.formData.conversionGoal] Conversion goal of this campaign
 * @param { string } [args.formData.locale] Language setting of this campaign (en/kr/jp)
 * @param { string } [args.formData.offerHeading] Offer heading of this campaign
 * @param { string } [args.formData.offerImageTitle] Offer image title of this campaign
 * @param { string } [args.formData.offerImageCaption] Offer image caption of this campaign
 * @param { string } [args.formData.offerInstructions] Offer instruction of this campaign
 * @param { string } [args.formData.redirectUrl] Url redirected to when user clicks the share  (required)
 * @param { string } [args.formData.shareTitle] Share title of this campaign
 * @param { string } [args.formData.shareMessage] Share message of this campaign
 * @param { string } [args.formData.offerImage] Offer image file (binary)
 * @param { string } [args.formData.shareVideo] Share video of this campaign (binary)
 * @param { string } [args.formData.thankYouImage] Thank you image of this campaign (binary)
 * @param { string } [args.formData.thankYouImageMobile] Thank you image for mobile users of this campaign (binary)
 * @param { string } [args.formData.offerImageMobile] Offer image for mobile users of this campaign (binary)
 * @param { string } [args.formData.shareImage] Share image of this campaign (binary)
 * @param { string } [args.formData.giftCardValue]
 * @param { string } [args.formData.termsAndConditionsURL]
 * @param { string } [args.formData.privacyPolicyURL]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createCampaign$1 = (args = {
  formData: {}
}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'multipart/form-data'
  };
  return IcsResource$1.post(`campaigns/`, args.formData, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * PATCH UpdateCampaign
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { object } args.formData the form data to update the campaign
 * @param { string } [args.formData.active] &quot;True&quot; by default
 * @param { string } [args.formData.name] Name of this campaign (required)
 * @param { string } [args.formData.emailSubject] Email subject of this campaign
 * @param { string } [args.formData.fromEmail] Email address of this campaign
 * @param { string } [args.formData.conversionGoal] Conversion goal of this campaign
 * @param { string } [args.formData.locale] Language setting of this campaign (en/kr/jp)
 * @param { string } [args.formData.offerHeading] Offer heading of this campaign
 * @param { string } [args.formData.offerImageTitle] Offer image title of this campaign
 * @param { string } [args.formData.offerImage] Offer image file (binary)
 * @param { string } [args.formData.offerImageCaption] Offer image caption of this campaign
 * @param { string } [args.formData.offerImageMobile] Offer image for mobile users of this campaign (binary)
 * @param { string } [args.formData.offerInstructions] Offe rinstruction of this campaign
 * @param { string } [args.formData.redirectUrl] Url redirected to when user clicks the share (required)
 * @param { string } [args.formData.shareTitle] Share title of this campaign
 * @param { string } [args.formData.shareMessage] Share message of this campaign
 * @param { string } [args.formData.shareVideo] Share video of this campaign (binary)
 * @param { string } [args.formData.thankYouImage] Thank you image of this campaign (binary)
 * @param { string } [args.formData.thankYouImageMobile] Thank you image for mobile users of this campaign (binary)
 * @param { string } [args.formData.shareImage] Share image of this campaign
 * @param { string } [args.formData.termsAndConditionsURL]
 * @param { string } [args.formData.privacyPolicyURL]
 * @param { string } [args.formData.giftCardValue]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateCampaign$1 = (args = {
  formData: {}
}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'multipart/form-data'
  };
  return IcsResource$1.patch(`campaigns/${args.campaignId}`, args.formData, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * DELETE DeleteCampaign
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteCampaign$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.delete(`campaigns/${args.campaignId}`, {
    data: {},
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET CheckInfluencerProcessing
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const checkInfluencerProcessing = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`campaigns/${args.campaignId}/checkInfluencerProcessing`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET CheckForValidGateway
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const checkForValidGateway = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`campaigns/${args.campaignId}/checkValidRefundGateway`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetCampaignEcommerceInjectableScript
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.providerId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCampaignEcommerceInjectableScript = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`campaigns/${args.campaignId}/provider/${args.providerId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetConversionsOfCampaign
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.limit] Maximum number of conversions to display
 * @param { String } [args.skip] Amount of conversions to skip from displaying
 * @param { String } [args.revenueGTOE] Min. revenue of conversions
 * @param { String } [args.revenueLTOE] Max. revenue of conversions
 * @param { String } [args.conversionDateGTOE] Conversion created start date (yyyy-mm-dd format)
 * @param { String } [args.conversionDateLTOE] Conversion created end date (yyyy-mm-dd format)
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCampaignConversions = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`campaigns/${args.campaignId}/paginatedConversions`, {
    params: {
      limit: args.limit,
      skip: args.skip,
      revenueGTOE: args.revenueGTOE,
      revenueLTOE: args.revenueLTOE,
      conversionDateGTOE: args.conversionDateGTOE,
      conversionDateLTOE: args.conversionDateLTOE,
      type: args.type,
      converted: args.converted,
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET ExportCampaignConversions
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const exportConversions$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`campaigns/${args.campaignId}/conversions/export`, {
    params: {
      search: args.search,
      revenueGTOE: args.revenueGTOE,
      revenueLTOE: args.revenueLTOE,
      conversionDateGTOE: args.conversionDateGTOE,
      conversionDateLTOE: args.conversionDateLTOE,
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

var index$n = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getCampaignsByLevel: getCampaignsByLevel,
	getCampaigns: getCampaigns,
	getCampaignById: getCampaignById$1,
	createCampaign: createCampaign$1,
	updateCampaign: updateCampaign$1,
	deleteCampaign: deleteCampaign$1,
	checkInfluencerProcessing: checkInfluencerProcessing,
	checkForValidGateway: checkForValidGateway,
	getCampaignEcommerceInjectableScript: getCampaignEcommerceInjectableScript,
	getCampaignConversions: getCampaignConversions,
	exportConversions: exportConversions$1
});

/**
 * ClientV1
 */

/**
 * GET GetClientByLevel
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.affiliateId] Affiliate or sub-affiliate ID of clients (required)
 * @param { String } [args.searchText] Search text used to filter clients
 * @param { String } [args.statusSearch] Filter for client status (active or disabled)
 * @param { String } [args.affiliateSearch] Fliter for affiliate ID related to clients
 * @param { String } [args.clientSearch] Fliter for client ID related to clients
 * @param { String } [args.order] Name of property to order
 * @param { String } [args.orderBy] Type of ordering (&quot;asc&quot; or &quot;desc&quot;)
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getClientByLevel = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`level-clients`, {
    params: {
      affiliateId: args.affiliateId,
      searchText: args.searchText,
      statusSearch: args.statusSearch,
      affiliateSearch: args.affiliateSearch,
      clientSearch: args.clientSearch,
      order: args.order,
      orderBy: args.orderBy,
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetClientById
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.clientId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getClientById$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`clients/${args.clientId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * POST CreateClient
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { string } [args.name]
 * @param { number } [args.affiliateId]
 * @param { string } [args.status]
 * @param { boolean } [args.isArchived]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createClient = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`clients`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * PATCH UpdateClient
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.clientId]
 * @param { string } [args.name]
 * @param { number } [args.affiliateId]
 * @param { string } [args.status]
 * @param { boolean } [args.isArchived]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateClient$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.patch(`clients/${args.clientId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * DELETE DeleteClient
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.clientId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteClient$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.delete(`clients/${args.clientId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * Unsubscribe from emails
 * @param {*} args
 * @param {*} params
 * @param {*} headers
 * @returns
 */
const unsubscribe$2 = ({
  campaignId,
  publicKey,
  email,
  ...args
}, params = {}, headers = {}) => {
  return IcsResource$1.post(`client/campaigns/${campaignId}/influencer/unsubscribe`, args, {
    params: {
      publicKey,
      email,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * Unsubscribe from emails
 * @param {*} args
 * @param {*} params
 * @param {*} headers
 * @returns
 */
const resubscribe$2 = ({
  campaignId,
  publicKey,
  email,
  ...args
}, params = {}, headers = {}) => {
  return IcsResource$1.post(`client/campaigns/${campaignId}/influencer/resubscribe`, args, {
    params: {
      publicKey,
      email,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

var index$m = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getClientByLevel: getClientByLevel,
	getClientById: getClientById$1,
	createClient: createClient,
	updateClient: updateClient$1,
	deleteClient: deleteClient$1,
	unsubscribe: unsubscribe$2,
	resubscribe: resubscribe$2
});

/**
 * CompanyV1
 */

/**
 * GET GetCompany
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.clientId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCompany = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`company/${args.clientId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * PATCH EditCompany
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.clientId]
 * @param { object } args.formData
 * @param { number } [args.formData.processorId]
 * @param { string } [args.formData.name]
 * @param { string } [args.formData.emailAddress]
 * @param { string } [args.formData.businessAddress]
 * @param { string } [args.formData.logo]
 * @param { string } [args.formData.cardFlexSecurityKey]
 * @param { boolean } [args.formData.maskInfo]
 * @param { boolean } [args.formData.isConfigured]
 * @param { string } [args.formData.termsAndConditionsURL]
 * @param { string } [args.formData.privacyPolicyURL]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const editCompany = (args = {
  formData: {}
}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'multipart/form-data'
  };
  return IcsResource$1.patch(`company/${args.clientId}`, args.formData, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

var index$l = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getCompany: getCompany,
	editCompany: editCompany
});

/**
 * CookiesV1
 */

/**
 * GET SetCookieAndRedirectOnInviteClick
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.influencerInviteHash]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const setCookieAndRedirectOnInviteClick = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`invite/${args.influencerInviteHash}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

var index$k = /*#__PURE__*/Object.freeze({
	__proto__: null,
	setCookieAndRedirectOnInviteClick: setCookieAndRedirectOnInviteClick
});

/**
 * CustomerV1
 */

/**
 * POST CreateInfluencerWithPublicKey
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.conCampaignId]
 * @param { String } [args.publicKey]
 * @param { string } [args.orderId]
 * @param { string } [args.identifier]
 * @param { string } [args.email]
 * @param { string } [args.revenue]
 * @param { string } [args.name]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createInfluencerWithPublicKey = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`client/campaigns/${args.conCampaignId}/influencers`, args, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

/**
 * POST CreateGmailInvite
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.publicKey]
 * @param { string } [args.name]
 * @param { string } [args.identifier]
 * @param { string } [args.shareMessage]
 * @param { string } [args.redirectUrl]
 * @param { Object } [args.items]
 * @param { Object } [args.items.0]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createGmailInvite = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`client/campaigns/${args.campaignId}/influencers/${args.influencerId}/invites/gm`, args, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

/**
 * POST CreateGenericInvite
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.publicKey]
 * @param { string } [args.name]
 * @param { string } [args.identifier]
 * @param { string } [args.shareMessage]
 * @param { string } [args.redirectUrl]
 * @param { Object } [args.items]
 * @param { Object } [args.items.0]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createGenericInvite$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`client/campaigns/${args.campaignId}/influencers/${args.influencerId}/invites/generic`, args, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

/**
 * POST CreateFacebookInvite
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.publicKey]
 * @param { string } [args.name]
 * @param { string } [args.identifier]
 * @param { string } [args.shareMessage]
 * @param { string } [args.redirectUrl]
 * @param { Object } [args.items]
 * @param { Object } [args.items.0]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createFacebookInvite$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`client/campaigns/${args.campaignId}/influencers/${args.influencerId}/invites/fb`, args, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

/**
 * POST CreateInviteHashAndCookies
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.publicKey]
 * @param { string } [args.referrer]
 * @param { boolean } [args.passBack]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createInviteHashAndCookies$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`client/pageView/`, args, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

/**
 * GET SetInviteCookieAndRedirect
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.influencerInviteHash]
 * @param { String } [args.publicKey]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const setInviteCookieAndRedirect = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`invite/${args.influencerInviteHash}`, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

/**
 * POST CreateIntermidiaryConversion
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { string } [args.identifier]
 * @param { string } [args.channel]
 * @param { string } [args.conversionIdentifier]
 * @param { string } [args.conversionType]
 * @param { boolean } [args.inviteTracking]
 * @param { boolean } [args.getOrCreateInfluencer]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createIntermidiaryConversion = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`client/campaigns/${args.campaignId}/track-conversion`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

/**
 * POST CreateIntermidiaryConversion
 * @description the "V2" of the "V1" version
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { string } [args.identifier]
 * @param { string } [args.channel]
 * @param { string } [args.conversionIdentifier]
 * @param { string } [args.conversionType]
 * @param { boolean } [args.inviteTracking]
 * @param { boolean } [args.getOrCreateInfluencer]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createInfluencer2 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`client/campaigns/${args.campaignId}/influencersV2`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

/**
 * GET PublicGetCampaign
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.publicKey]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const publicGetCampaign = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json',
    Referer: 'https://asjfdkl.icecreamsocial.io'
  };
  return IcsResource$1.get(`client/campaigns/${args.campaignId}`, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

var index$j = /*#__PURE__*/Object.freeze({
	__proto__: null,
	createInfluencerWithPublicKey: createInfluencerWithPublicKey,
	createGmailInvite: createGmailInvite,
	createGenericInvite: createGenericInvite$1,
	createFacebookInvite: createFacebookInvite$1,
	createInviteHashAndCookies: createInviteHashAndCookies$1,
	setInviteCookieAndRedirect: setInviteCookieAndRedirect,
	createIntermidiaryConversion: createIntermidiaryConversion,
	createInfluencer2: createInfluencer2,
	publicGetCampaign: publicGetCampaign
});

/**
 * EmailV1
 */

/**
 * POST UnsubscribeEmail
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { string } [args.email]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const unsubscribeEmail = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.post(`email/unsubscribe`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

/**
 * PATCH ResubscrubeEmail
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { string } [args.email]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const resubscrubeEmail = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.patch(`email/resubscribe`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
};

var index$i = /*#__PURE__*/Object.freeze({
	__proto__: null,
	unsubscribeEmail: unsubscribeEmail,
	resubscrubeEmail: resubscrubeEmail
});

/**
 * InfluencersV1
 */

/**
 * GET GetInfluencers
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.limit] Maximum number of influencers to display
 * @param { String } [args.skip] Amount of influencers to skip from displaying
 * @param { String } [args.invitesGTOE] Min. invites of influencers
 * @param { String } [args.invitesLTOE] Max. invites of influencers
 * @param { String } [args.invitesClickCountGTOE] Min. clicks of influencers
 * @param { String } [args.invitesClickCountLTOE] Max. clicks of influencers
 * @param { String } [args.conversionsGTOE] Min. conversions of influencers
 * @param { String } [args.conversionsLTOE] Max. conversions of influencers
 * @param { String } [args.revenueGTOE] Min. revenue of influencers
 * @param { String } [args.revenueLTOE] Max. revenue of influencers
 * @param { String } [args.createdDateGTOE] Influencers created start date (yyyy-mm-dd format)
 * @param { String } [args.createdDateLTOE] Influencers created end date (yyyy-mm-dd format)
 * @param { String } [args.goalReached] Conversion goal reached? (boolean)
 * @param { String } [args.processed] Conversion goal processed and reward given? (boolean)
 * @param { String } [args.hideInfluencerWithoutShare] Hide influencers without shares? (boolean)
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getInfluencers$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`campaigns/${args.campaignId}/influencers`, {
    params: {
      limit: args.limit,
      skip: args.skip,
      invitesGTOE: args.invitesGTOE,
      invitesLTOE: args.invitesLTOE,
      invitesClickCountGTOE: args.invitesClickCountGTOE,
      invitesClickCountLTOE: args.invitesClickCountLTOE,
      conversionsGTOE: args.conversionsGTOE,
      conversionsLTOE: args.conversionsLTOE,
      revenueGTOE: args.revenueGTOE,
      revenueLTOE: args.revenueLTOE,
      createdDateGTOE: args.createdDateGTOE,
      createdDateLTOE: args.createdDateLTOE,
      goalReached: args.goalReached,
      processed: args.processed,
      hideInfluencerWithoutShare: args.hideInfluencerWithoutShare,
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetInfluencerById
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getInfluencerById$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`campaigns/${args.campaignId}/influencers/${args.influencerId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET ExportInfluencers
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const exportInfluencers$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`campaigns/${args.campaignId}/influencers/export`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * POST CreateInfluencer
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { string } [args.orderId]
 * @param { string } [args.email]
 * @param { string } [args.revenue]
 * @param { string } [args.name]
 * @param { string } [args.identifier]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createInfluencer$3 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`campaigns/${args.campaignId}/influencers`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * PATCH UpdateInfluencer
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { string } [args.orderId]
 * @param { string } [args.email]
 * @param { string } [args.revenue]
 * @param { string } [args.name]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateInfluencer$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.patch(`campaigns/${args.campaignId}/influencers/${args.influencerId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * DELETE DeleteInfluencer
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteInfluencer$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.delete(`campaigns/${args.campaignId}/influencers/${args.influencerId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetInvitesByInfluencerId
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getInvitesByInfluencerId$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`campaigns/${args.campaignId}/influencers/${args.influencerId}/invites`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetConversionByInfluencerId
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getConversionByInfluencerId = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`campaigns/${args.campaignId}/influencers/${args.influencerId}/conversions`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetInviteByInfluencerAndInviteId
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.inviteId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getInviteByInfluencerAndInviteId = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`campaigns/${args.campaignId}/influencers/${args.influencerId}/invites/${args.inviteId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetConversionsByInfluencerAndInviteId
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.inviteId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getConversionsByInfluencerAndInviteId = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`campaigns/${args.campaignId}/influencers/${args.influencerId}/invites/${args.inviteId}/conversions`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetInfluencedConversionByInvitedInfluencerId
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getInfluencedConversionByInvitedInfluencerId = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`campaigns/${args.campaignId}/influencers/${args.influencerId}/influencedConversions`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * DELETE DeleteConversion
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.conversionId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteConversion = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.delete(`campaigns/${args.campaignId}/influencers/${args.influencerId}/conversions/${args.conversionId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * POST IssueCliqRefundReward
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const issueCliqRefundReward = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`campaigns/${args.campaignId}/influencers/${args.influencerId}/cardFlexRefund`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * POST ProcessInfluencer
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.influencerId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const processInfluencer$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`campaigns/${args.campaignId}/influencers/${args.influencerId}/processInfluencer`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

var index$h = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getInfluencers: getInfluencers$1,
	getInfluencerById: getInfluencerById$1,
	exportInfluencers: exportInfluencers$1,
	createInfluencer: createInfluencer$3,
	updateInfluencer: updateInfluencer$1,
	deleteInfluencer: deleteInfluencer$1,
	getInvitesByInfluencerId: getInvitesByInfluencerId$1,
	getConversionByInfluencerId: getConversionByInfluencerId,
	getInviteByInfluencerAndInviteId: getInviteByInfluencerAndInviteId,
	getConversionsByInfluencerAndInviteId: getConversionsByInfluencerAndInviteId,
	getInfluencedConversionByInvitedInfluencerId: getInfluencedConversionByInvitedInfluencerId,
	deleteConversion: deleteConversion,
	issueCliqRefundReward: issueCliqRefundReward,
	processInfluencer: processInfluencer$1
});

/**
 * InvitesV1
 */

/**
 * GET GetInvitesOfCampaign
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.limit] Maximum number of invites to display
 * @param { String } [args.skip] Amount of invites to skip from displaying
 * @param { String } [args.inviteClickCountGTOE] Min. click counts of invites
 * @param { String } [args.inviteClickCountLTOE] Max. click counts of invites
 * @param { String } [args.conversionsGTOE] Min. conversions of invites
 * @param { String } [args.conversionsLTOE] Max. conversions of invites
 * @param { String } [args.revenueGTOE] Min. revenue of invites
 * @param { String } [args.revenueLTOE] Max. revenue of invites
 * @param { String } [args.invitationDateGTOE] Invites created start date (yyyy-mm-dd format)
 * @param { String } [args.invitationDateLTOE] Invites created end date (yyyy-mm-dd format)
 * @param { String } [args.type] Type of invite (fb for Facebook and gm for Gmail)
 * @param { String } [args.converted] Is there any conversion? (boolean)
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getInvitesOfCampaign = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`campaigns/${args.campaignId}/invites`, {
    params: {
      limit: args.limit,
      skip: args.skip,
      inviteClickCountGTOE: args.inviteClickCountGTOE,
      inviteClickCountLTOE: args.inviteClickCountLTOE,
      conversionsGTOE: args.conversionsGTOE,
      conversionsLTOE: args.conversionsLTOE,
      revenueGTOE: args.revenueGTOE,
      revenueLTOE: args.revenueLTOE,
      invitationDateGTOE: args.invitationDateGTOE,
      invitationDateLTOE: args.invitationDateLTOE,
      type: args.type,
      converted: args.converted,
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * PATCH UpdateInvite
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.inviteId]
 * @param { string } [args.type]
 * @param { string } [args.name]
 * @param { string } [args.identifier]
 * @param { string } [args.email]
 * @param { string } [args.shareMessage]
 * @param { string } [args.redirectUrl]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateInvite$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.patch(`invites/${args.inviteId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET ExportInvites
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const exportInvites$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`campaigns/${args.campaignId}/invites/export`, {
    params: {
      inviteClickCountGTOE: args.inviteClickCountGTOE,
      inviteClickCountLTOE: args.inviteClickCountLTOE,
      conversionsGTOE: args.conversionsGTOE,
      conversionsLTOE: args.conversionsLTOE,
      revenueGTOE: args.revenueGTOE,
      revenueLTOE: args.revenueLTOE,
      invitationDateGTOE: args.invitationDateGTOE,
      invitationDateLTOE: args.invitationDateLTOE,
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

var index$g = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getInvitesOfCampaign: getInvitesOfCampaign,
	updateInvite: updateInvite$1,
	exportInvites: exportInvites$1
});

/**
 * ProcessorsV1
 */

/**
 * POST CreateProcessor
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.clientId]
 * @param { String } [args.companyId]
 * @param { string } [args.type]
 * @param { string } [args.squareAppId]
 * @param { string } [args.squareLocationId]
 * @param { string } [args.squareLocationName]
 * @param { string } [args.squareAppAccessToken]
 * @param { string } [args.squareOAuthAccessToken]
 * @param { string } [args.squareOAuthAccessTokenExpiration]
 * @param { string } [args.squareOAuthRefreshToken]
 * @param { string } [args.squareMerchantId]
 * @param { string } [args.cardFlexSecurityKey]
 * @param { number } [args.clientId]
 * @param { number } [args.companyId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createProcessor$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`processors/client/${args.clientId}/company/${args.companyId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * PATCH UpdateProcessor
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.clientId]
 * @param { String } [args.companyId]
 * @param { String } [args.processorId]
 * @param { string } [args.type]
 * @param { string } [args.squareAppId]
 * @param { string } [args.squareLocationId]
 * @param { string } [args.squareLocationName]
 * @param { string } [args.squareAppAccessToken]
 * @param { string } [args.squareOAuthAccessToken]
 * @param { string } [args.squareOAuthAccessTokenExpiration]
 * @param { string } [args.squareOAuthRefreshToken]
 * @param { string } [args.squareMerchantId]
 * @param { string } [args.cardFlexSecurityKey]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateProcessor$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.patch(`processors/client/${args.clientId}/company/${args.companyId}/processor/${args.processorId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * DELETE DeleteProcessor
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.clientId]
 * @param { String } [args.companyId]
 * @param { String } [args.processorId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteProcessor$1 = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.delete(`processors/client/${args.clientId}/company/${args.companyId}/processor/${args.processorId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetProcessorById
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.clientId]
 * @param { String } [args.processorId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getProcessorById = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`processors/client/${args.clientId}/processor/${args.processorId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetSquareProcessorLocations
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.clientId]
 * @param { String } [args.processorId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getSquareProcessorLocations = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`processors/client/${args.clientId}/processor/${args.processorId}/locations`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetProcessors
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.clientId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getProcessors = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.get(`processors/client/${args.clientId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * POST CreateProcessor
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.clientId]
 * @param { String } [args.companyId]
 * @param { String } [args.processorId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const revokeSquareAccessToken = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`processors/client/${args.clientId}/company/${args.companyId}/processor/${args.processorId}/revokeSquareToken`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

var index$f = /*#__PURE__*/Object.freeze({
	__proto__: null,
	createProcessor: createProcessor$1,
	updateProcessor: updateProcessor$1,
	deleteProcessor: deleteProcessor$1,
	getProcessorById: getProcessorById,
	getSquareProcessorLocations: getSquareProcessorLocations,
	getProcessors: getProcessors,
	revokeSquareAccessToken: revokeSquareAccessToken
});

/**
 * UsersV1
 */

/**
 * GET GetUsersByLevel
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.affiliateId] Affiliate or sub-affiliate ID of users (required)
 * @param { String } [args.clientId] Client ID of users (required)
 * @param { String } [args.searchText] Search text used to filter users
 * @param { String } [args.accessLevelSearch] Filter by access level
 * @param { String } [args.clientSearch] Fliter for affiliate ID related to users
 * @param { String } [args.order] Name of property to order
 * @param { String } [args.orderBy] Type of ordering (&quot;asc&quot; or &quot;desc&quot;)
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getUsersByLevel = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`level-users`, {
    params: {
      affiliateId: args.affiliateId,
      clientId: args.clientId,
      searchText: args.searchText,
      accessLevelSearch: args.accessLevelSearch,
      clientSearch: args.clientSearch,
      order: args.order,
      orderBy: args.orderBy,
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetUsers
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getUsers = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`users`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET GetUserById
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.userId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getUserById = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`users/${args.userId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * POST CreateUser
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { null } [args.affiliateId]
 * @param { number } [args.clientId]
 * @param { string } [args.company]
 * @param { string } [args.email]
 * @param { string } [args.firstName]
 * @param { boolean } [args.isTeamAdmin]
 * @param { string } [args.lastName]
 * @param { string } [args.password]
 * @param { string } [args.role]
 * @param { boolean } [args.isArchived]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createUser = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`users`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * POST GenerateStateParam
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const generateStateParam = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.post(`users/getUserStateParam`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * PATCH UpdateUser
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.userId]
 * @param { null } [args.affiliateId]
 * @param { number } [args.clientId]
 * @param { string } [args.company]
 * @param { string } [args.email]
 * @param { string } [args.firstName]
 * @param { boolean } [args.isTeamAdmin]
 * @param { string } [args.lastName]
 * @param { string } [args.role]
 * @param { boolean } [args.isArchived]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateUser = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };
  return IcsResource$1.patch(`users/${args.userId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * DELETE DeleteUser
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.userId]
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteUser = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.delete(`users/${args.userId}`, {
    params: {
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET DailyStats
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.fromDate] From date that is used to populate the daily statistics (yyyy-mm-dd format)
 * @param { String } [args.toDate] End date that is used to populate the daily statistics (yyyy-mm-dd format)
 * @param { String } [args.campaignId] Campaign ID that is used to populate daily statistics
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const dailyStats = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`users/daily-stats`, {
    params: {
      fromDate: args.fromDate,
      toDate: args.toDate,
      campaignId: args.campaignId,
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

/**
 * GET StatisticsOverview
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.fromDate] From date that is used to populate statistics overview (yyyy-mm-dd format)
 * @param { String } [args.toDate] End date that is used to populate statistics overview (yyyy-mm-dd format)
 * @param { String } [args.campaignId] Campaign ID that is used to populate statistics overview
 * @param { String } [args.jwt]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const statisticsOverview = (args = {}, params = {}, headers = {}) => {
  const defaultHeaders = {};
  return IcsResource$1.get(`users/stats-overview`, {
    params: {
      fromDate: args.fromDate,
      toDate: args.toDate,
      campaignId: args.campaignId,
      ...params
    },
    headers: {
      ...defaultHeaders,
      Authorization: args.jwt,
      ...headers
    }
  });
};

var index$e = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getUsersByLevel: getUsersByLevel,
	getUsers: getUsers,
	getUserById: getUserById,
	createUser: createUser,
	generateStateParam: generateStateParam,
	updateUser: updateUser,
	deleteUser: deleteUser,
	dailyStats: dailyStats,
	statisticsOverview: statisticsOverview
});

var index$d = /*#__PURE__*/Object.freeze({
	__proto__: null,
	V1Resource: IcsResource$1,
	AccountCreationV1: index$q,
	AffiliateV1: index$p,
	ApiKeysV1: index$o,
	CampaignsV1: index$n,
	ClientV1: index$m,
	CompanyV1: index$l,
	CookiesV1: index$k,
	CustomerV1: index$j,
	EmailV1: index$i,
	InfluencersV1: index$h,
	InvitesV1: index$g,
	ProcessorsV1: index$f,
	UsersV1: index$e
});

/**
 * A shared instance for ICS API
 */
var IcsResource = axios.create({
  baseURL: process.env.BASE_API_ENDPOINT_V2
});

/**
 * Affiliates
 */

/**
 *  GetAffiliateById
 * Get information of a single affiliate by **affiliateId** . 
The retrieved affiliate must belong to the logged in user&#x27;s hierarchy of affiliate.
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.affiliateId] (Required) 
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getAffiliateById = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`affiliates/${args.affiliateId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  DeleteAnAffiliate
 * This request will delete the target affiliate if you have the access to manage it.
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.affiliateId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteAnAffiliate = (args = {}, params = {}, headers = {}) => {
  return IcsResource.delete(`affiliates/${args.affiliateId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  UpdateAnAffiliate
 * This request will update the target affiliate if you have the access do manage it.
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.affiliateId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateAnAffiliate = (args = {}, params = {}, headers = {}) => {
  const {
    affiliateId,
    ...body
  } = args;
  return IcsResource.put(`affiliates/${affiliateId}`, body, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreateAnAffiliate
 * This request will create an affiliate under the provided parent affiliate ID. 
Once new affiliate is created, you may create new users or new orgnazation structures (affiliate or client) under it.
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createAnAffiliate = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`affiliates`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetNestedAffiliatesByAffiliateId
 * This request will return all the hierarchy of affiliates belonging to the logged in user&#x27;s affiliate. 
This call is used to see which affliates can be managed with your current access.
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getNestedAffiliatesByAffiliateId = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`affiliates/nested-affiliates/level`, {
    params: {
      affiliateId: args.affiliateId,
      parentAffiliateId: args.parentAffiliateId,
      searchText: args.searchText,
      orderField: args.orderField,
      orderBy: args.orderBy,
      status: args.status,
      isArchived: args.isArchived,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

var index$c = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getAffiliateById: getAffiliateById,
	deleteAnAffiliate: deleteAnAffiliate,
	updateAnAffiliate: updateAnAffiliate,
	createAnAffiliate: createAnAffiliate,
	getNestedAffiliatesByAffiliateId: getNestedAffiliatesByAffiliateId
});

/**
 * Auth
 */

/**
 *  GetAuthorizationToken
 * Retrieves an authorization token to be able to request authenticated api calls.
If you do not have ICS credentials, please visit https://icecreamsocial.io/get-started/ to get a free trial or contact a member of ICS customer success team directly.
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getAuthorizationToken = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`auth/token`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

var index$b = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getAuthorizationToken: getAuthorizationToken
});

/**
 * Campaigns
 */

/**
 *  GetPaginatedInvites
 * Get Invites by campaignId
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getPaginatedInvites = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/invites`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  ExportInvites
 * Export information of invites as an excel file.
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const exportInvites = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/invites/export`, {
    params: {
      limit: args.limit,
      skip: args.skip,
      inviteGTOE: args.invitesGTOE,
      inviteLTOE: args.invitesLTOE,
      inviteClickCountGTOE: args.invitesClickCountGTOE,
      inviteClickCountLTOE: args.invitesClickCountLTOE,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetInvite
 * Get Invite by Influencer and Invite ID
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.influencerId] (Required)
 * @param {  } [args.inviteId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getInvite = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/influencers/${args.influencerId}/invites/${args.inviteId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  UpdateInvite
 * Update Invite by Invite ID
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.inviteId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateInvite = (args = {}, params = {}, headers = {}) => {
  return IcsResource.patch(`campaigns/${args.inviteId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetConversionsOfAnInvite
 * Retrieves all conversions resulted from an invite. Use this API request see trace the invite source of conversions and measure the impact of an invite.
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.influencerId] (Required)
 * @param {  } [args.inviteId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getConversionsOfAnInvite = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/influencers/${args.influencerId}/invites/${args.inviteId}/conversions`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  ExportConversions
 * Export information of conversions as an excel file.
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const exportConversions = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/conversions/export`, {
    params: {
      limit: args.limit,
      skip: args.skip,
      conversionGTOE: args.conversionGTOE,
      conversionLTOE: args.conversionLTOE,
      revenueGTOE: args.revenueGTOE,
      revenueLTOE: args.revenueLTOE,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetInvitesByInfluencerId
 * Retrive invites of an influencer using influencerId
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.influencerId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getInvitesByInfluencerId = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/influencers/${args.influencerId}/invites`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetInfluencedConversionsByInvitedInfluencerId
 * Retrieves all the conversions resulted by the invites of the influencer whose ID is provided. Use this API request to get of list of influenced conversions that can be managed for the influencer.
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.influencerId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getInfluencedConversionsByInvitedInfluencerId = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/influencers/${args.influencerId}/influencedConversions`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetConversionsByInfluencerId
 * Get Conversion by Influencer ID
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.influencerId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getConversionsByInfluencerId = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/influencers/${args.influencerId}/conversions`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * Cancel Conversion
 * Marks a conversion as cancelled
 *
 * @param {object} args
 * @param {*} params
 * @param {*} headers
 * @returns {*}
 */

const cancelConversion = ({
  campaignId,
  influencerId,
  conversionId,
  ...args
}, params = {}, headers = {}) => {
  return IcsResource.post(`campaigns/${campaignId}/influencers/${influencerId}/conversions/${conversionId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  DeleteAConversion
 * Delete an conversion of an influencer. Use this API request can be used when there is cancellation or refund of purchases.
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.influencerId] (Required)
 * @param {  } [args.conversionId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteAConversion = (args = {}, params = {}, headers = {}) => {
  return IcsResource.delete(`campaigns/${args.campaignId}/influencers/${args.influencerId}/conversions/${args.conversionId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetInfluencerById
 * Get information of an influencer by camapaign and influencer ID
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) Campaign ID
 * @param {  } [args.influencerId] (Required) Infleuncer ID
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getInfluencerById = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/influencers/${args.influencerId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  AnonymizeInfluencer
 * Scrub an Influencer's data
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.influencerId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const anonymizeInfluencer = ({
  campaignId,
  influencerId,
  ...args
} = {}, params = {}, headers = {}) => {
  return IcsResource.put(`campaigns/${campaignId}/influencers/${influencerId}/anonymize`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  UpdateInfluencer
 * Update information on an Influencer with a campaign ID and influencer ID
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.influencerId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateInfluencer = ({
  campaignId,
  influencerId,
  ...args
} = {}, params = {}, headers = {}) => {
  return IcsResource.put(`campaigns/${campaignId}/influencers/${influencerId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  DeleteInfluencer
 * Delete Influencer from a campagin
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.influencerId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteInfluencer = (args = {}, params = {}, headers = {}) => {
  return IcsResource.delete(`campaigns/${args.campaignId}/influencers/${args.influencerId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  Review Processing
 * Get processing information of an influencer by camapaign and influencer ID.
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.influencerId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const reviewProcessing = (args = {}, params = {}, headers = {}) => {
  const {
    campaignId,
    influencerId
  } = args;
  return IcsResource.get(`campaigns/${campaignId}/influencers/${influencerId}/review-processing`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  ProcessInfluencer
 * Get information of an influencer by camapaign and influencer ID.
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.influencerId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const processInfluencer = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`campaigns/${args.campaignId}/influencers/${args.influencerId}/processInfluencer`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreateManualConversion
 * Create a manual conversion foe testing or admin related purpose
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.influencerId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createManualConversion = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`campaigns/${args.campaignId}/influencers/${args.influencerId}/createManualConversion`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreateInfluencer
 * Create an influencer. If the cookie is set, a conversion should be triggered once the influencer has been created (given that it is a unique Influencer)
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) The campaign ID
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createInfluencer$2 = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`campaigns/${args.campaignId}/influencers`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetInfluencers
 * Get information of all influencers of a campaign.
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getInfluencers = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/influencers`, {
    params: {
      limit: args.limit,
      skip: args.skip,
      invitesGTOE: args.invitesGTOE,
      invitesLTOE: args.invitesLTOE,
      invitesClickCountGTOE: args.invitesClickCountGTOE,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  ExportInfluencers
 * Export information of influencers as an excel file.
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const exportInfluencers = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/influencers/export`, {
    params,
    headers: {
      ...headers
    }
  });
};

/**
 *  GetCampaignById
 * Get a campaign&#x27;s information by campaign ID
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCampaignById = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  UpdateCampaign
 * Update a campaign&#x27;s information. Note that this API documentation platform does not support &quot;multipart/form-data&quot;. 
To make this request correctly, use &quot;multipart/form-data&quot; and upload files for &quot;...Image&quot; fields.
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) 
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateCampaign = (args = {}, params = {}, headers = {}) => {
  const {
    campaignId,
    formData
  } = args;
  return IcsResource.put(`campaigns/${campaignId}`, formData, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  DeleteCampaign
 * Delete a campaign
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteCampaign = (args = {}, params = {}, headers = {}) => {
  return IcsResource.delete(`campaigns/${args.campaignId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetConversionsOfACampaign
 * Get all conversions of a campaign
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getConversionsOfACampaign = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/conversions`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetPaginatedConversions
 * Get all conversions of a campaign in a paginated form
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getPaginatedConversions = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/paginatedConversions`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  RefundGatewayVerification
 * Check if refund processor is valid before processing influencer reward
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const refundGatewayVerification = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/checkValidRefundGateway`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  ShowInfluencerRewardInformation
 * Show influencer reward information for confirmation
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const showInfluencerRewardInformation = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/checkInfluencerProcessing`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetIcsScriptByIntegrationPlatformMethod
 * Get ICS script by integration platform method
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param {  } [args.providerId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getIcsScriptByIntegrationPlatformMethod = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/provider/${args.providerId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreateCampaign
 * Create an Icecream Social campaign. Note that this API documentation platform does not support &quot;multipart/form-data&quot;. 
To make this request correctly, use &quot;multipart/form-data&quot; and upload files for &quot;...Image&quot; fields.
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createCampaign = (args = {}, params = {}, headers = {}) => {
  const {
    formData
  } = args;
  return IcsResource.post(`campaigns`, formData, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetCampaignByFilter
 * Get campaign by filter and affiliate hierchical group
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCampaignByFilter = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/nested`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  Unsubscribe
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { string } args.campaignId required
 * @param { string } args.influencerId required
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const unsubscribe$1 = (args, params = {}, headers = {}) => {
  const {
    campaignId,
    influencerId,
    ...body
  } = args;
  return IcsResource.post(`campaigns/${campaignId}/influencers/${influencerId}/unsubscribe`, body, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  Resubscribe
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { string } args.campaignId required
 * @param { string } args.influencerId required
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const resubscribe$1 = (args, params = {}, headers = {}) => {
  const {
    campaignId,
    influencerId,
    ...body
  } = args;
  return IcsResource.post(`campaigns/${campaignId}/influencers/${influencerId}/resubscribe`, body, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetCampaignDiscounts
 * Get campaign discounts
 *
 * @param { Object } args
 * @param { string } [args.campaignId] the campaign id to find discounts for
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCampaignDiscounts$1 = (args = {}, params = {}, headers = {}) => {
  const {
    campaignId
  } = args;
  return IcsResource.get(`campaigns/${campaignId}/discounts`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetCampaignDiscounts
 * Get campaign discounts
 *
 * @param { Object } args
 * @param { string } [args.campaignId] the campaign id to find discounts for
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateCampaignDiscounts = (args = {}, params = {}, headers = {}) => {
  const {
    campaignId,
    ...body
  } = args;
  return IcsResource.post(`campaigns/${campaignId}/discounts`, body, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

var index$a = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getPaginatedInvites: getPaginatedInvites,
	exportInvites: exportInvites,
	getInvite: getInvite,
	updateInvite: updateInvite,
	getConversionsOfAnInvite: getConversionsOfAnInvite,
	exportConversions: exportConversions,
	getInvitesByInfluencerId: getInvitesByInfluencerId,
	getInfluencedConversionsByInvitedInfluencerId: getInfluencedConversionsByInvitedInfluencerId,
	getConversionsByInfluencerId: getConversionsByInfluencerId,
	cancelConversion: cancelConversion,
	deleteAConversion: deleteAConversion,
	getInfluencerById: getInfluencerById,
	anonymizeInfluencer: anonymizeInfluencer,
	updateInfluencer: updateInfluencer,
	deleteInfluencer: deleteInfluencer,
	reviewProcessing: reviewProcessing,
	processInfluencer: processInfluencer,
	createManualConversion: createManualConversion,
	createInfluencer: createInfluencer$2,
	getInfluencers: getInfluencers,
	exportInfluencers: exportInfluencers,
	getCampaignById: getCampaignById,
	updateCampaign: updateCampaign,
	deleteCampaign: deleteCampaign,
	getConversionsOfACampaign: getConversionsOfACampaign,
	getPaginatedConversions: getPaginatedConversions,
	refundGatewayVerification: refundGatewayVerification,
	showInfluencerRewardInformation: showInfluencerRewardInformation,
	getIcsScriptByIntegrationPlatformMethod: getIcsScriptByIntegrationPlatformMethod,
	createCampaign: createCampaign,
	getCampaignByFilter: getCampaignByFilter,
	unsubscribe: unsubscribe$1,
	resubscribe: resubscribe$1,
	getCampaignDiscounts: getCampaignDiscounts$1,
	updateCampaignDiscounts: updateCampaignDiscounts
});

/**
 * Client
 */

/**
 *  CreateFacebookInvite
 * Create a facebook invite for an influencer
 * @deprecated
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) campaign ID
 * @param {  } [args.influencerId] (Required) influencer ID
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createFacebookInvite = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`client/public/campaigns/${args.campaignId}/influencers/${args.influencerId}/invites/fb`, args, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreateGenericInvite
 * Create a generic invite for an influencer
 * @deprecated
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) campaign ID
 * @param {  } [args.influencerId] (Required) influencer ID
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createGenericInvite = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`client/public/campaigns/${args.campaignId}/influencers/${args.influencerId}/invites/generic`, args, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreateEmailInvite
 * Create an email invite for an influencer
 * @deprecated
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) the campaign ID
 * @param {  } [args.influencerId] (Required) the influencer ID
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createEmailInvite = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`client/public/campaigns/${args.campaignId}/influencers/${args.influencerId}/invites/gm`, args, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreateInfluencer
 * Create an influencer for a campaign
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) campaign ID
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createInfluencer$1 = (args = {}, params = {}, headers = {}) => {
  const {
    campaignId,
    ...body
  } = args;
  return IcsResource.post(`client/public/campaigns/${campaignId}/influencers`, body, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetCampaignInformation
 * Public call to get a campaign&#x27;s information
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCampaignInformation = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`client/public/campaigns/${args.campaignId}`, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreateInfluencerFromClientIntermediaryConversion
 *
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createInfluencerFromClientIntermediaryConversion = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`client/public/campaigns/${args.campaignId}/track-conversion`, args, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  SendEmailToInfluencer
 * Send email to an influencer with invite information
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) the campaign ID
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const sendEmailToInfluencer = (args = {}, params = {}, headers = {}) => {
  const {
    campaignId,
    ...body
  } = args;
  return IcsResource.post(`client/public/campaigns/${campaignId}/email`, body, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreateInviteHashAndCookies
 * Create invite hash and cookies used for redirecting invitee to ICS confirmation page.
 * @deprecated
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createInviteHashAndCookies = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`client/public/campaigns/pageView`, args, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * Unsubscribe from emails
 * @param {*} args
 * @param {*} params
 * @param {*} headers
 * @returns
 */
const unsubscribe = ({
  campaignId,
  publicKey,
  email,
  ...args
}, params = {}, headers = {}) => {
  return IcsResource.post(`client/public/campaigns/${campaignId}/influencers/unsubscribe`, args, {
    params: {
      publicKey,
      email,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * Unsubscribe from emails
 * @param {*} args
 * @param {*} params
 * @param {*} headers
 * @returns
 */
const resubscribe = ({
  campaignId,
  publicKey,
  email,
  ...args
}, params = {}, headers = {}) => {
  return IcsResource.post(`client/public/campaigns/${campaignId}/influencers/resubscribe`, args, {
    params: {
      publicKey,
      email,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetCampaignInformation
 * Public call to get a campaign&#x27;s information
 *
 * @param { Object } args
 * @param { string } [args.campaignId] (Required)
 * @param { string } [args.publicKey] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCampaignDiscounts = (args = {}, params = {}, headers = {}) => {
  const {
    campaignId,
    publicKey
  } = args;
  return IcsResource.get(`client/public/campaigns/${campaignId}/discounts`, {
    params: {
      publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * GET PublicGetCampaignSettings
 * @todo add description
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { String } [args.campaignId]
 * @param { String } [args.publicKey]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCampaignSettings = (args = {}, params = {}, headers = {}) => {
  const {
    campaignId,
    publicKey
  } = args;
  return IcsResource.get(`client/public/campaigns/${campaignId}/settings`, {
    params: {
      ...params,
      publicKey
    },
    headers: {
      ...headers
    }
  });
};

var index$9 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	createFacebookInvite: createFacebookInvite,
	createGenericInvite: createGenericInvite,
	createEmailInvite: createEmailInvite,
	createInfluencer: createInfluencer$1,
	getCampaignInformation: getCampaignInformation,
	createInfluencerFromClientIntermediaryConversion: createInfluencerFromClientIntermediaryConversion,
	sendEmailToInfluencer: sendEmailToInfluencer,
	createInviteHashAndCookies: createInviteHashAndCookies,
	unsubscribe: unsubscribe,
	resubscribe: resubscribe,
	getCampaignDiscounts: getCampaignDiscounts,
	getCampaignSettings: getCampaignSettings
});

/**
 * Clients
 */

/**
 *  GetClientById
 * Get information of a single client by client ID
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.clientId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getClientById = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`clients/${args.clientId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  DeleteClient
 * Delete a client
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.clientId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const deleteClient = (args = {}, params = {}, headers = {}) => {
  return IcsResource.delete(`clients/${args.clientId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  UpdateClient
 * Update a client
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.clientId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updateClient = (args = {}, params = {}, headers = {}) => {
  return IcsResource.put(`clients/${args.clientId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreateAClient
 * Create a client
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createAClient = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`clients`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreateClientUseCase
 * Create a client use case in twilio
 *
 * @param { Object } args
 * @param { string } [args.clientId] client id to create a twilio use case for
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createClientUseCase = (args = {}, params = {}, headers = {}) => {
  const {
    clientId,
    ...body
  } = args;
  return IcsResource.post(`clients/${clientId}/useCase`, body, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetClientUseCase
 * Get client use case status in twilio
 *
 * @param { Object } args
 * @param { string } [args.clientId] client id to create a twilio use case for
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getClientUseCaseStatus = (args = {}, params = {}, headers = {}) => {
  const {
    clientId
  } = args;
  return IcsResource.get(`clients/${clientId}/useCase`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetNestedClients
 * Get clients by filter. This request will return all the hierarchy of clients belonging to the logged in user&#x27;s affiliate.
This call is used to see which clients can be managed with your current access
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getNestedClients = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`clients/nested-clients/level`, {
    params: {
      affiliateId: args.affiliateId,
      searchText: args.searchText,
      affiliateFilterId: args.affiliateFilterId,
      clientFilterId: args.clientFilterId,
      orderField: args.orderField,
      orderBy: args.orderBy,
      status: args.status,
      isArchived: args.isArchived,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  RegeneratePublicKey
 * Regenerate public key for a client
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.clientId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const regeneratePublicKey = (args = {}, params = {}, headers = {}) => {
  return IcsResource.put(`clients/regenPublicKey/${args.clientId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

var index$8 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getClientById: getClientById,
	deleteClient: deleteClient,
	updateClient: updateClient,
	createAClient: createAClient,
	createClientUseCase: createClientUseCase,
	getClientUseCaseStatus: getClientUseCaseStatus,
	getNestedClients: getNestedClients,
	regeneratePublicKey: regeneratePublicKey
});

/**
 * Company
 */

/**
 * GetCompanyInformation
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { } [args.clientId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the API Resource
 */
const getCompanyInformation = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`company/${args.clientId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * UpdateCompanyInformation
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { } [args.clientId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the API Resource
 */
const updateCompanyInformation = (args = {}, params = {}, headers = {}) => {
  const {
    clientId,
    formData
  } = args;
  return IcsResource.put(`company/${clientId}`, formData, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * Propagates settings to company's campaigns
 *
 * @name BulkUpdateCompanyCampaigns
 *
 * @param {*} args
 * @param {*} params
 * @param {*} headers
 * @returns
 */
const bulkUpdateCompanyCampaigns = ({
  clientId,
  ...args
}, params = {}, headers = {}) => {
  return IcsResource.put(`company/${clientId}/campaigns`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

var index$7 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getCompanyInformation: getCompanyInformation,
	updateCompanyInformation: updateCompanyInformation,
	bulkUpdateCompanyCampaigns: bulkUpdateCompanyCampaigns
});

const getMarketSegments = (params = {}, headers = {}) => {
    return IcsResource.get(`marketsegments`, {
        params: Object.assign({}, params),
        headers: Object.assign({}, headers),
    });
};

var index$6 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getMarketSegments: getMarketSegments
});

/**
 * Processors
 */

/**
 * GetProcessorInformationById
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.clientId] (Required)
 * @param {  } [args.processorId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getProcessorInformationById = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`processors/client/${args.clientId}/processor/${args.processorId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * GetAllAccessibleProcessors
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.clientId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getAllAccessibleProcessors = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`processors/client/${args.clientId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * GetSquareLocationsOfTheSquareProcessor
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.clientId] (Required)
 * @param {  } [args.processorId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 */
const getSquareLocationsOfTheSquareProcessor = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`processors/client/${args.clientId}/processor/${args.processorId}/locations`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};
/**
 * CreateProcessor
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.clientId] (Required)
 * @param {  } [args.companyId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 */
const createProcessor = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`processors/client/${args.clientId}/company/${args.companyId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * UpdateProcessorInformation
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.clientId] (Required)
 * @param {  } [args.companyId] (Required)
 * @param {  } [args.processorId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 */
const updateProcessor = (args = {}, params = {}, headers = {}) => {
  return IcsResource.put(`processors/client/${args.clientId}/company/${args.companyId}/processor/${args.processorId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * DeleteProcessor
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.clientId] (Required)
 * @param {  } [args.companyId] (Required)
 * @param {  } [args.processorId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 */
const deleteProcessor = (args = {}, params = {}, headers = {}) => {
  return IcsResource.delete(`processors/client/${args.clientId}/company/${args.companyId}/processor/${args.processorId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * UpdateProcessorSquareToken
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.clientId] (Required)
 * @param {  } [args.companyId] (Required)
 * @param {  } [args.processorId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 */
const updateProcessorSquareToken = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`processors/client/${args.clientId}/company/${args.companyId}/processor/${args.processorId}/revokeSquareToken`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 * RevokeStripeToken
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.clientId] (Required)
 * @param {  } [args.companyId] (Required)
 * @param {  } [args.processorId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 */
const revokeStripeToken = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`processors/client/${args.clientId}/company/${args.companyId}/processor/${args.processorId}/revokeStripeToken`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

var index$5 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getProcessorInformationById: getProcessorInformationById,
	getAllAccessibleProcessors: getAllAccessibleProcessors,
	getSquareLocationsOfTheSquareProcessor: getSquareLocationsOfTheSquareProcessor,
	createProcessor: createProcessor,
	updateProcessor: updateProcessor,
	deleteProcessor: deleteProcessor,
	updateProcessorSquareToken: updateProcessorSquareToken,
	revokeStripeToken: revokeStripeToken
});

// Lambda API endpoints
/**
 * A shared instance for ICS API on AWS Lambda
 */
const LambdaResource = axios.create({
  baseURL: process.env.LAMBDA_ENDPOINT
});

/**
 *  GetWidget
 * Public call to get a campaign.
 *
 * @note Eventually we want this call to return a specified widget instead of just a campaign.
 *
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */

const getCampaign = (args = {}, params = {}, headers = {}) => {
  return LambdaResource.get(`v2/public/widget/${args.campaignId}`, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreateInfluencer
 * Create an influencer for a campaign
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) campaign ID
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createInfluencer = (args = {}, params = {}, headers = {}) => {
  const {
    campaignId,
    publicKey,
    ...body
  } = args;
  return LambdaResource.post(`v2/public/campaigns/${campaignId}/influencers`, body, {
    params: {
      publicKey: publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  emailInfluencer
 * Send email to an influencer with invite information
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) the campaign ID
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const emailInfluencer = (args = {}, params = {}, headers = {}) => {
  const {
    campaignId,
    ...body
  } = args;
  return LambdaResource.post(`v2/public/campaigns/${campaignId}/email`, body, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  trackConversion
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const trackConversion = (args = {}, params = {}, headers = {}) => {
  return LambdaResource.post(`v2/public/campaigns/${args.campaignId}/track-conversion`, args, {
    params: {
      publicKey: args.publicKey,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

var index$4 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getCampaign: getCampaign,
	createInfluencer: createInfluencer,
	emailInfluencer: emailInfluencer,
	trackConversion: trackConversion
});

/**
 * Rewards
 */

/**
 *  GetPaginatedRewards
 *  Get a paginated list of rewards
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { } [args.campaignId]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getPaginatedRewards = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/rewards`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetRewardsExport
 *  Get an export file of rewards
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { } [args.campaignId]
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getRewardsExport = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`campaigns/${args.campaignId}/rewards/export`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

var index$3 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getPaginatedRewards: getPaginatedRewards,
	getRewardsExport: getRewardsExport
});

/**
 * Users
 */

/**
 *  GetASingleUserInformationByUserId
 * Get User by ID
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.userId] (Required)
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getASingleUserInformationByUserId = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`users/${args.userId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  UpdatesAUser
 * Updates an admin user
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.userId] (Required) The user id to update
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const updatesAUser = (args = {}, params = {}, headers = {}) => {
  return IcsResource.put(`users/${args.userId}`, args.body, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetAdminUsers
 * Retrieves list of admin users
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getAdminUsers = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`users`, {
    params: {
      limit: args.limit,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  CreatesAdminUser
 * Creates an amdin user
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const createsAdminUser = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`users`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetNestedAdminUsersByAffiliateId
 * Retrieves list of admin users that are nested within the provided affiliate id
and its nested sub-affiliates. This call is recursive and will return all 
users within the hierarchy of the provided affiliate id.
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getNestedAdminUsersByAffiliateId = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`users/nested-users/level`, {
    params: {
      affiliateId: args.affiliateId,
      searchText: args.searchText,
      accessLevelSearch: args.accessLevelSearch,
      affiliateFilterId: args.affiliateFilterId,
      clientFilterId: args.clientFilterId,
      orderField: args.orderField,
      orderBy: args.orderBy,
      status: args.status,
      isArchived: args.isArchived,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetCampaignOverviewStatistics
 * Get statistics overview of a specified campaign or set of campaigns.

Note: if no filtering params are provided, default behavior will be for response to give campaign stats of campaigns mapped to user making call
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getCampaignOverviewStatistics = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`users/stats/stats-overview`, {
    params: {
      fromDate: args.fromDate,
      toDate: args.toDate,
      campaignId: args.campaignId,
      clientId: args.clientId,
      affiliateId: args.affiliateId,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetDailyCampaignStatistics
 * Get daily statistics of a specified campaign or all campaigns.
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getDailyCampaignStatistics = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`users/stats/daily-stats`, {
    params: {
      fromDate: args.fromDate,
      toDate: args.toDate,
      campaignId: args.campaignId,
      clientId: args.clientId,
      affiliateId: args.affiliateId,
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GenerateUserStateParam
 *
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const generateUserStateParam = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`users/user-state-param`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

var index$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getASingleUserInformationByUserId: getASingleUserInformationByUserId,
	updatesAUser: updatesAUser,
	getAdminUsers: getAdminUsers,
	createsAdminUser: createsAdminUser,
	getNestedAdminUsersByAffiliateId: getNestedAdminUsersByAffiliateId,
	getCampaignOverviewStatistics: getCampaignOverviewStatistics,
	getDailyCampaignStatistics: getDailyCampaignStatistics,
	generateUserStateParam: generateUserStateParam
});

/**
 * Webhooks
 */

/**
 *  RegisterCampaignToWebhook
 * Creates a subscription for a specific webhook event to a campaign.
Supply the campain ID to register to and webhook notification details.
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) The campaign&#x27;s identifier
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const registerCampaignToWebhook = (args = {}, params = {}, headers = {}) => {
  return IcsResource.post(`api/v2/webhooks/campaign/${args.campaignId}`, args, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetRegisteredCampaignWebhooks
 * Retrieves a list of subscribed webhook events for a certain campaign
Supply the campaign ID of interest
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) The campaign&#x27;s identifier
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getRegisteredCampaignWebhooks = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`api/v2/webhooks/campaign/${args.campaignId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  RemoveWebhookSubscription
 * Deletes subscription to a webhook event for a certain campaign
Supply the campaign ID and subscription ID
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param {  } [args.campaignId] (Required) The campaign&#x27;s identifier
 * @param {  } [args.webhookSubscriptionId] (Required) The subscription&#x27;s identifier
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const removeWebhookSubscription = (args = {}, params = {}, headers = {}) => {
  return IcsResource.delete(`api/v2/webhooks/campaign/${args.campaignId}/subscription/${args.webhookSubscriptionId}`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

/**
 *  GetWebhookEvents
 * Retrieves system wide events that can trigger webhooks and can 
be subscribed to.
eventId: 1 &#x3D; order_conversion
eventId: 2 &#x3D; influencer_created
eventId: 3 &#x3D; invite_created
 * 
 * @param { Object } args
 * @param { string } [args.baseUrl] override the base api url
 * @param { Object } [params = {}] optional way to pass query params. will override query params passed in args with same key
 * @param { Object } [headers = {}] optional way to pass headers. will override headers passed in args
 * @returns {*} the  API Resource
 */
const getWebhookEvents = (args = {}, params = {}, headers = {}) => {
  return IcsResource.get(`api/v2/webhooks/events`, {
    params: {
      ...params
    },
    headers: {
      ...headers
    }
  });
};

var index$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	registerCampaignToWebhook: registerCampaignToWebhook,
	getRegisteredCampaignWebhooks: getRegisteredCampaignWebhooks,
	removeWebhookSubscription: removeWebhookSubscription,
	getWebhookEvents: getWebhookEvents
});

var index = /*#__PURE__*/Object.freeze({
	__proto__: null,
	Affiliates: index$c,
	Auth: index$b,
	Campaigns: index$a,
	Client: index$9,
	Clients: index$8,
	Company: index$7,
	MarketSegments: index$6,
	Processors: index$5,
	Public: index$4,
	Rewards: index$3,
	Users: index$2,
	Webhooks: index$1
});

export { index$d as IcsV1, index as V2 };
